<template>
  <div>
    <h2>Interviews</h2>
    <InterviewListItem
      shouldRedirectToGlobalDetails
      v-for="(interview, index) in userData.interviewSlots"
      :key="index"
      :interview="interview"
    />
  </div>
</template>

<script>
import InterviewListItem from "@/views/bookings/BookingInterviews/components/InterviewListItem";

export default {
  name: "WorkerInterviews",
  components: {
    InterviewListItem
  },
  props: {
    userData: {
      type: Object,
      required: true
    }
  }
};
</script>
